import React from 'react';
import { Dropdown } from 'react-bootstrap';
import './DropDownButton.css';

// --- Reusable and Dynamic Components ---

// The interface for a single dropdown item
export interface DropdownItem {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
}

// The props for our new dynamic dropdown button
interface DynamicDropdownButtonProps {
  title: string;
  items: DropdownItem[];
}

// The custom toggle component remains the same
interface CustomToggleProps {
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const CustomToggle = React.forwardRef<HTMLButtonElement, CustomToggleProps>(({ children, onClick }, ref) => (
  <button
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className="btn btn--small fake-button"
  >
    {children} &#x25bc;
  </button>
));

// The dynamic DropdownButton component
const DynamicDropdownButton: React.FC<DynamicDropdownButtonProps> = ({ title, items }) => {
  return (
    <div id="grid-report-slicers">
      <Dropdown>
        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
          {title}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {items.map((item, index) => (
            <Dropdown.Item as={"button"} key={index} onClick={item.onClick}>
              {item.icon && <span style={{ marginRight: '10px' }}>{item.icon}</span>}
              {item.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default DynamicDropdownButton;
